<template>
	<div v-loading="loading">
		<div class="wrap wrap_page fixed">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="企业信息" name="first"></el-tab-pane>
				<el-tab-pane label="经济效益" name="second"></el-tab-pane>
				<el-tab-pane label="专业化程度" name="third"></el-tab-pane>
				<el-tab-pane label="创新能力" name="fourth"></el-tab-pane>
				<el-tab-pane label="经营管理" name="six"></el-tab-pane>
				<el-tab-pane label="资料生成" name="seven"></el-tab-pane>
			</el-tabs>
		</div>

		<div class="wrap wrap_page" style="margin-top:70px;">
			<div class="text"><i class="red">*</i> 产品生产执行标准</div>
			<div class="content cont_top">
				<!-- <div style="width: 100px"></div> -->
				<el-form
					:rules="rules"
					:model="param"
					ref="ruleForm1"
					label-position="left"
				>
					<el-form-item
						prop="zjtxProductProductionStandardBO.standardName"
						label="名称"
						label-width="60px"
					>
						<div>
							<el-input
								placeholder="输入内容"
								v-model="param.zjtxProductProductionStandardBO.standardName"
								style="width:200px;"
							></el-input>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div class="content cont_top checkboxs">
				<el-checkbox-group v-model="standardTypeCheck">
					<el-checkbox
						v-for="item in productStandardTypes"
						:key="item.dictCode"
						:label="item.dictCode"
						>{{ item.dictName }}</el-checkbox
					>
				</el-checkbox-group>
			</div>
		</div>

		<div class="wrap wrap_page">
			<div class="text">产品获得发达国家或地区权威机构认证情况(多选)</div>

			<div class="content cont_top">
				<el-checkbox-group v-model="productDevelopedAuthConditionChecked">
					<el-checkbox
						v-for="item in productDevelopedAuthCondition"
						:key="item.dictCode"
						:label="item.dictCode"
						>{{ item.dictName }}</el-checkbox
					>
				</el-checkbox-group>
			</div>
			<div class="content cont_top">
				<el-input
					type="textarea"
					placeholder="请说明"
					v-model="productDevelopedAuthConditionIntroduce"
				></el-input>
			</div>

			<div class="content cont_top">
				<div class="fujian cont_r">
					<div class="txt">获得发达国家或地区权威机构认证材料22</div>
					<div class="txt">
						附件说明：附件最多可上传10个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
					</div>
					<el-upload
						class="upload-demo"
						:action="uploadImgUrl"
						:on-success="uploadSuccess"
						:on-preview="handleView"
						:before-upload="beforeUploadZjtx"
						:on-remove="handleRemove"
						:before-remove="beforeRemove"
						:limit="10"
						:on-exceed="handleExceed"
						:file-list="fileList17"
						:data="{ moduleType: 17 }"
						:on-error="uploadError"
					>
						<el-button size="small" type="primary"
							><i class="el-icon-upload"></i> 点击上传</el-button
						>
					</el-upload>
				</div>
			</div>
		</div>

		<div class="wrap wrap_page">
			<div class="text">
				<i class="red">*</i> 企业获得的管理体系认证情况（可多选）
			</div>

			<el-form :rules="rules">
				<div class="content cont_top">
					<!-- <el-form-item prop="manageSystemConditionsChecked"> -->
					<el-checkbox-group v-model="manageSystemConditionsChecked">
						<el-checkbox
							v-for="item in manageSystemConditions"
							:key="item.dictCode"
							:label="item.dictCode"
							name="manageSystemConditionsChecked"
							>{{ item.dictName }}</el-checkbox
						>
					</el-checkbox-group>
					<!-- </el-form-item> -->
				</div>
				<div class="content cont_top">
					<el-form-item style="width:100%;" label="">
						<el-input
							type="textarea"
							placeholder="请说明"
							v-model="manageSystemConditionsIntroduce"
						></el-input>
					</el-form-item>
				</div>
			</el-form>

			<div class="content cont_top">
				<div class="fujian cont_r">
					<div class="txt">获得发达国家或地区权威机构认证材料</div>
					<div class="txt">
						附件说明：附件最多可上传10个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX
					</div>
					<el-upload
						class="upload-demo"
						:action="uploadImgUrl"
						:on-preview="handleView"
						:before-upload="beforeUploadZjtx"
						:on-remove="handleRemove"
						:before-remove="beforeRemove"
						:on-success="uploadSuccess"
						:limit="10"
						:data="{ moduleType: 18 }"
						:on-exceed="handleExceed"
						:file-list="fileList18"
						:on-error="uploadError"
					>
						<el-button size="small" type="primary"
							><i class="el-icon-upload"></i> 点击上传</el-button
						>
					</el-upload>
				</div>
			</div>
		</div>

		<div class="wrap wrap_page">
			<div class="text">
				<i class="red">*</i> 企业总体情况简要介绍（400字以内）
			</div>
			<el-form :model="param" :rules="rules" ref="ruleForm">
				<div class="content cont_top">
					<el-form-item
						prop="zjtxProjectBO.operatingStateIntroduct"
						style="width:100%;"
					>
						<el-input
							type="textarea"
							placeholder="请输入"
							class="cont_textarea"
							:autosize="{ minRows: 4 }"
							v-model="param.zjtxProjectBO.operatingStateIntroduct"
							maxlength="400"
							show-word-limit
						></el-input>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="wrap wrap_page">
			<div class="text">企业总体情况备注（400字以内）</div>
			<div class="content cont_top">
				<el-input
					type="textarea"
					placeholder="请输入"
					class="cont_textarea"
					:autosize="{ minRows: 4 }"
					v-model="param.zjtxProjectBO.operatingStateRemark"
					maxlength="400"
					show-word-limit
				></el-input>
			</div>
		</div>

		<div class="flex flex-center" style="margin-top: 20px">
			<el-button type="primary" @click="save()">保存</el-button>
			<el-button type="primary" @click="reset()">重置</el-button>
			<el-button type="primary" @click="data_page()">下一步</el-button>
		</div>
	</div>
</template>

<script>
import { getDict, getModuleFiles } from "@/api/ChinaHigh";
import {
	saveOperatingManagement,
	getOperatingManagementBaseInfo
} from "@/api/specialization";

export default {
	data() {
		return {
			loading: false,
			rules: {
				"zjtxProductProductionStandardBO.standardName": [
					{ required: true, message: "请填写该项", trigger: "blur" }
				],
				manageSystemConditionsChecked: {
					type: "array",
					required: true,
					message: "请至少选择一个活动性质",
					trigger: "change"
				},
				"zjtxProjectBO.operatingStateIntroduct": {
					required: true,
					message: "请填写",
					trigger: "blur"
				},
				manageSystemConditionsIntroduce: {
					required: true,
					message: "请填写",
					trigger: "blur"
				}
			},
			param: {
				files: [],
				zjtxProductProductionStandardBO: {},
				zjtxMultipleChoiceRecordBO: [],
				zjtxProjectBO: {},
				zjtxProductProductionStandardTypeBO: []
			},
			fileList17: [],
			fileList18: [],
			activeName: "six",
			productStandardTypes: [],
			standardTypeCheck: [],
			productDevelopedAuthCondition: [],
			productDevelopedAuthConditionChecked: [],
			productDevelopedAuthConditionIntroduce: "",
			manageSystemConditions: [],
			manageSystemConditionsChecked: [],
			manageSystemConditionsIntroduce: "",
			idResponse: {}
		};
	},
	created() {
		this.init();
	},
	methods: {
		reset() {
			this.fileList17 = [];
			this.fileList18 = [];
			this.param.files = [];
			this.standardTypeCheck = [];
			this.param.zjtxProductProductionStandardBO = {
				id: this.param.zjtxProductProductionStandardBO.id
			};
			this.param.zjtxProjectBO = { id: this.param.zjtxProjectBO.id };
			this.param.zjtxMultipleChoiceRecordBO = [];
			this.param.zjtxProductProductionStandardTypeBO = [];
			this.manageSystemConditionsChecked = [];
			this.productDevelopedAuthConditionChecked = [];
			this.manageSystemConditionsIntroduce = "";
			this.productDevelopedAuthConditionIntroduce = "";
		},
		uploadSuccess(res, file) {
			this.loading = false;
			if (res.code == "00000") {
				this.msgSuccess("上传成功");
				if (res.data.moduleType == 17) {
					this.fileList17.push(file);
				}
				if (res.data.moduleType == 18) {
					this.fileList18.push(file);
				}
			}
		},
		uploadError() {
			this.msgError("上传失败");
			this.loading = false;
		},
		save() {
			let result = false;
			this.$refs["ruleForm"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm1"].validate(valid => {
				result = valid;
			});
			if (result) {
				this.param.files = [{ moduleType: 17 }, { moduleType: 18 }];
				console.log(this.param);
				this.fileList17.forEach(res => {
					this.param.files.push(res.response.data);
				});
				this.fileList18.forEach(res => {
					this.param.files.push(res.response.data);
				});
				this.param.zjtxProductProductionStandardTypeBO = [];
				this.standardTypeCheck.forEach(res => {
					this.param.zjtxProductProductionStandardTypeBO.push({
						standardTypeId: res
					});
				});
				let answer = "";
				this.productDevelopedAuthConditionChecked.forEach(res => {
					console.log(res);
					answer = answer + res + ",";
				});
				this.param.zjtxMultipleChoiceRecordBO = [];
				if (Object.keys(this.idResponse).length > 0) {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "1",
						introduce: this.productDevelopedAuthConditionIntroduce,
						id: this.idResponse.MultipleChoiceRecord0
					});
				} else {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "1",
						introduce: this.productDevelopedAuthConditionIntroduce
					});
				}
				answer = "";
				this.manageSystemConditionsChecked.forEach(res => {
					answer = answer + res + ",";
				});
				if (Object.keys(this.idResponse).length > 0) {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "2",
						introduce: this.manageSystemConditionsIntroduce,
						id: this.idResponse.MultipleChoiceRecord1
					});
				} else {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "2",
						introduce: this.manageSystemConditionsIntroduce
					});
				}
				saveOperatingManagement(this.param).then(res => {
					if (res.code == "00000") {
						if (res.data != null) {
							this.idResponse = res.data;
							this.param.zjtxProductProductionStandardBO.id =
								res.data.ProductProductionStandard;
						}
						this.msgSuccess("操作成功");
					}
				});
			}
		},
		init() {
			getDict({ type: "product_standard_type" }).then(res => {
				this.productStandardTypes = res.data;
			});
			getDict({ type: "product_developed_auth_condition" }).then(res => {
				this.productDevelopedAuthCondition = res.data;
			});
			getDict({ type: "management_system_auth_condition" }).then(res => {
				this.manageSystemConditions = res.data;
			});
			this.param.zjtxProjectBO.id = sessionStorage.getItem("zt_special_id");
			getOperatingManagementBaseInfo(this.param.zjtxProjectBO.id).then(res => {
				this.param.zjtxProjectBO = res.data.zjtxProjectBO
					? res.data.zjtxProjectBO
					: { id: this.param.zjtxProjectBO.id };
				this.param.zjtxProductProductionStandardBO =
					res.data.zjtxProductProductionStandardBO != null
						? res.data.zjtxProductProductionStandardBO
						: {};
				res.data.zjtxProductProductionStandardTypeBO.forEach(item => {
					this.standardTypeCheck.push(parseInt(item.standardTypeId));
				});
				res.data.zjtxMultipleChoiceRecordBO.forEach(item => {
					if (item.relationType == 1) {
						let answer = item.answer;
						this.idResponse.MultipleChoiceRecord0 = item.id;
						if (item.answer && item.answer.length > 0) {
							item.answer.split(",").forEach(itm => {
								this.productDevelopedAuthConditionChecked.push(parseInt(itm));
							});
						}
						this.productDevelopedAuthConditionIntroduce = item.introduce;
					} else if (item.relationType == 2) {
						this.manageSystemConditionsIntroduce = item.introduce;
						let answer = item.answer;
						this.idResponse.MultipleChoiceRecord1 = item.id;
						if (item.answer && item.answer.length > 0) {
							item.answer.split(",").forEach(itm => {
								this.manageSystemConditionsChecked.push(parseInt(itm));
							});
						}
					}
				});
				// console.log(res);
			});
			getModuleFiles({
				moduleId: sessionStorage.getItem("zt_special_id"),
				moduleType: 17
			}).then(res => {
				this.fileList17 = [];
				res.data.forEach(re => {
					re.name = re.fileName;
					re.response = { data: {} };
					re.response.data.moduleType = re.moduleType;
					re.response.data.moduleId = re.moduleId;
					re.response.data.fileName = re.fileName;
					re.response.data.path = re.path;
					this.fileList17.push(re);
				});
			});
			getModuleFiles({
				moduleId: sessionStorage.getItem("zt_special_id"),
				moduleType: 18
			}).then(res => {
				this.fileList18 = [];
				res.data.forEach(re => {
					re.name = re.fileName;
					re.response = { data: {} };
					re.response.data.moduleType = re.moduleType;
					re.response.data.moduleId = re.moduleId;
					re.response.data.fileName = re.fileName;
					re.response.data.path = re.path;
					this.fileList18.push(re);
					// this.fileList17.push(re);
				});
			});
		},
		handleClick(tab, event) {
			console.log(tab.index);
			this.$confirm(
				"请确认当前页数据是否填写完整并保存,否则将导致数据丢失",
				"确认离开吗?",
				{ type: "warning" }
			)
				.then(() => {
					if (tab.index == 0) {
						this.$router.push("/centerform/specializationRegistration");
					} else if (tab.index == 1) {
						this.$router.push("/centerform/specializationBenefit");
					} else if (tab.index == 2) {
						this.$router.push("/centerform/specializationProfessionalization");
					} else if (tab.index == 3) {
						this.$router.push("/centerform/specializationInnovationCapacity");
					} else if (tab.index == 4) {
						this.$router.push("/centerform/specializationManagement");
					} else if (tab.index == 5) {
						this.$router.push("/centerform/specializationDatagenerated");
					}
				})
				.catch(e => {
					this.activeName = "six";
				});
		},
		handleRemove(file, fileList) {
			if (file.response.data.moduleType == 17) {
				this.fileList17 = [];
				fileList.forEach(item => {
					this.fileList17.push(item);
				});
			}
			if (file.response.data.moduleType == 18) {
				this.fileList18 = [];
				fileList.forEach(item => {
					this.fileList18.push(item);
				});
			}
		},
		handlePreview(file) {
			console.log(file);
		},
		handleExceed(files, fileList) {
			this.$message.warning(
				`当前限制选择 3 个文件，本次选择了 ${
					files.length
				} 个文件，共选择了 ${files.length + fileList.length} 个文件`
			);
		},
		beforeRemove(file, fileList) {},
		beforeUploadZjtx(file, fileList) {
			let suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
			if (suffix != "pdf" && suffix != "doc" && suffix != "docx") {
				this.msgError("只能上传pdf/doc/docx格式的文件");
				return false;
			}
			if (file.size > 10240000) {
				this.msgError("文件最大可上传10MB,您上传的" + file.name + "已超出限制");
				return false;
			}
			// this.loading = true;
		},
		data_page: function() {
			let result = false;
			this.$refs["ruleForm"].validate(valid => {
				result = valid;
			});
			this.$refs["ruleForm1"].validate(valid => {
				result = valid;
			});
			if (result) {
				this.param.files = [{ moduleType: 17 }, { moduleType: 18 }];
				console.log(this.param);
				this.fileList17.forEach(res => {
					this.param.files.push(res.response.data);
				});
				this.fileList18.forEach(res => {
					this.param.files.push(res.response.data);
				});
				this.param.zjtxProductProductionStandardTypeBO = [];
				this.standardTypeCheck.forEach(res => {
					this.param.zjtxProductProductionStandardTypeBO.push({
						standardTypeId: res
					});
				});
				let answer = "";
				this.productDevelopedAuthConditionChecked.forEach(res => {
					console.log(res);
					answer = answer + res + ",";
				});
				this.param.zjtxMultipleChoiceRecordBO = [];
				if (Object.keys(this.idResponse).length > 0) {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "1",
						introduce: this.productDevelopedAuthConditionIntroduce,
						id: this.idResponse.MultipleChoiceRecord0
					});
				} else {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "1",
						introduce: this.productDevelopedAuthConditionIntroduce
					});
				}
				answer = "";
				this.manageSystemConditionsChecked.forEach(res => {
					answer = answer + res + ",";
				});
				if (Object.keys(this.idResponse).length > 0) {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "2",
						introduce: this.manageSystemConditionsIntroduce,
						id: this.idResponse.MultipleChoiceRecord1
					});
				} else {
					this.param.zjtxMultipleChoiceRecordBO.push({
						answer: answer.substr(0, answer.length - 1),
						relationType: "2",
						introduce: this.manageSystemConditionsIntroduce
					});
				}
				saveOperatingManagement(this.param).then(res => {
					if (res.code == "00000") {
						if (res.data != null) {
							this.idResponse = res.data;
							this.param.zjtxProductProductionStandardBO.id =
									res.data.ProductProductionStandard;
						}
						this.msgSuccess("操作成功");
						this.$router.push("/centerform/specializationDatagenerated");
					}
				});
			}
		}
	}
};
</script>

<style scoped>
.text {
	border-bottom: 1px solid #dbdbdb;
	position: relative;
	padding: 10px 20px;
}
.text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 12px;
	background: #7c99fd;
}
.icon-wujiaoxing {
	color: #d43030;
}
.content {
	width: 80%;
	display: flex;
	justify-content: flex-start;
	/* align-items: center; */
	margin-left: 100px;
}
.content .title_l {
	width: 200px;
	line-height: 40px;
}

.flex-justify .el-form-item {
	width: 40%;
}
.cont_r .txt {
	font-size: 13px;
	color: #999;
}
.upload-demo {
	margin-top: 20px;
}
.content .el-radio {
	margin-right: 20px;
}
.cont_top {
	margin-top: 14px;
}
.textarea {
	width: 100%;
}

.flex-around > div {
	flex: 1;
	margin-top: 20px;
}
.flex-around > div .el-input {
	width: 50%;
}
.red{
	color: #F65E5E;
}
#wrap {
	margin-top: 15px;
}
</style>
